import { ReactNode } from "react";
import styled from "styled-components";
import { elevation02, shade900, shade950 } from "../../styles/tokens";
import { Button } from "../button/Button.Parts";

// TEXT

// CONSTANTS
const PANEL_OPEN_MS = "350ms";
const PANEL_CLOSE_MS = "250ms";
const PANEL_CURVE = "cubic-bezier(0.32, 0.72, 0, 1)";
const PANEL_WIDTH = "22.5rem";
export const PANEL_FOOTER_HEIGHT = "6rem";

// STYLES
export const PageWithPanel = styled.div`
  display: flex;
  flex: 1;
  flex-flow: row nowrap;
  align-items: stretch;
  min-width: 0;
`;

export const PanelOuterContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  align-self: stretch;
  box-sizing: border-box;
`;

export const PanelWrapper = styled.div`
  background-color: ${shade950};
  box-shadow: ${elevation02};
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 0;
  height: 100dvh;
  clip-path: inset(0px -200px -200px -200px);

  &[data-state="open"] {
    animation: panelExpand ${PANEL_OPEN_MS} ${PANEL_CURVE};
  }

  &[data-state="closed"] {
    animation: panelCollapse ${PANEL_CLOSE_MS} ${PANEL_CURVE};
  }

  @keyframes panelExpand {
    from {
      width: 0;
    }
    to {
      width: var(--radix-collapsible-content-width);
    }
  }

  @keyframes panelCollapse {
    from {
      width: var(--radix-collapsible-content-width);
    }
    to {
      width: 0;
    }
  }
`;

export const PanelContentSizer = styled.div`
  border-left: 1px solid ${shade900};
  min-height: 0;
  width: ${PANEL_WIDTH};
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const PanelCollapsibleInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  min-height: 0;
  clip-path: inset(0 0 -100vh 0);
  height: 100%;
  padding-top: 3rem;
`;

export const PanelFooter = styled.div`
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  flex-shrink: 0;
  width: ${PANEL_WIDTH};
  min-height: ${PANEL_FOOTER_HEIGHT};
  padding: 1.5rem;
  border-top: 1px solid ${shade900};
  background-color: ${shade950};

  /* the panel is narrow — buy back room so footer button text never wraps */
  ${Button} {
    padding: 0 1rem;
  }
`;

// DATA

// TYPES
export type Props = {
  header?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

// FUNCTIONS

// ASSETS
